import { ImageType } from "@/types/baseTypes";
import { TipTopfRecipeResponseType } from "./getFilteredRecipes";

type TipTopfRecipe = TipTopfRecipeResponseType["rezepte_list"][number];

export const getImageOrFallback = (
  recipe: TipTopfRecipe,
  fallback?: false | ImageType,
): ImageType | false => {
  if (recipe.bild_desktop == "") {
    return fallback ? fallback : false;
  }

  return {
    id: `${recipe.rezept_id}`,
    title: recipe.bild_titel,
    filename: "",
    url: recipe.bild_desktop,
    link: recipe.bild_desktop,
    alt: recipe.bild_alttext,
    name: recipe.bild_titel,
    description: recipe.bild_alttext,
    height: 252,
    width: 318,
    image_blur: "",
    acf: {
      link_1: "",
      link_2: "",
      text_1: "",
      text_2: "",
    },
  };
};

export const getApiPrefix = () => {
  return typeof window === "undefined" ? process.env.BACKEND_HOST : "/api";
};

/**
 * Sometimes there are recipes which have a underscore inside their title
 * (e.g. "Birchermüesli_1_online"). This function only return the part before
 * the first underscrore. This is (until now) the correct title
 *
 * @param title - title from the TipTopf recipe API
 * @returns string
 */
export const cropRecipeTitle = (title: string) => {
  if (!title.includes("_")) return title;

  return title.split("_")[0];
};
